<template>
  <teleport to="body">
    <div
      class="fixed inset-0 z-30 flex items-center justify-center bg-transparent"
    >
      <div
        class="fixed top-0 z-10 h-full w-full bg-dark-gray bg-opacity-50"
        @click.stop
      />
      <div
        class="content-box relative z-10 flex items-center justify-center scroll-auto rounded-xl bg-white px-4 md:px-6"
        style="width: 410px; height: 600px"
      >
        <div class="flex flex-col items-center justify-center gap-5">
          <img
            width="60"
            src="@/assets/warning-icon.svg"
            alt="Warning Icon"
          />
          <h1
            class="text-center font-medium text-steel-900"
            style="font-size: 24px"
          >
            VPN or Proxy Connection Detected
          </h1>
          <p class="text-base font-normal text-steel-900">
            It looks like you’re connected through a VPN or proxy. To continue,
            please disconnect from it and refresh your browser.
          </p>
          <p class="text-base font-normal text-steel-900">
            If you’re not using one, your company network or IT settings may be
            masking your IP address. In that case, please reach out to your IT
            team for help.
          </p>

          <ButtonComponent
            variant="primary"
            class="w-full"
            height="h-[40px]"
            @click="onRefresh"
          >
            Refresh
          </ButtonComponent>
          <p class="text-sm font-normal text-steel-900">
            Need Help? Contact us at
            <a
              class="text-sun-700 underline transition-colors duration-200 hover:text-sun-600 active:text-sun-800"
              href="mailto:service@highway.com"
            >
              service@highway.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script setup>
import ButtonComponent from '@/components/ButtonComponent.vue';
const emit = defineEmits(['refresh']);

const onRefresh = () => {
  emit('refresh');
};
</script>
